"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.absDocs = void 0;
var absDocs = exports.absDocs = {
  name: 'abs',
  category: 'Arithmetic',
  syntax: ['abs(x)'],
  description: 'Compute the absolute value.',
  examples: ['abs(3.5)', 'abs(-4.2)'],
  seealso: ['sign']
};